import { FunctionComponent } from 'preact';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useIcons } from '../../hooks/useIcons';

export const NextUpButton: FunctionComponent<IconButtonProps> = (props) => {
  const { Episodes } = useIcons();
  return (
    <IconButton {...props}>
      <Episodes />
    </IconButton>
  );
};
